var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIntersectSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.6665 4.65885C1.6665 3.72543 1.6665 3.25872 1.84816 2.9022C2.00795 2.5886 2.26292 2.33363 2.57652 2.17384C2.93304 1.99219 3.39975 1.99219 4.33317 1.99219H10.6665C11.5999 1.99219 12.0666 1.99219 12.4232 2.17384C12.7368 2.33363 12.9917 2.5886 13.1515 2.9022C13.3332 3.25872 13.3332 3.72543 13.3332 4.65885V10.9922C13.3332 11.9256 13.3332 12.3923 13.1515 12.7488C12.9917 13.0624 12.7368 13.3174 12.4232 13.4772C12.0666 13.6589 11.5999 13.6589 10.6665 13.6589H4.33317C3.39975 13.6589 2.93304 13.6589 2.57652 13.4772C2.26292 13.3174 2.00795 13.0624 1.84816 12.7488C1.6665 12.3923 1.6665 11.9256 1.6665 10.9922V4.65885Z",
    stroke: "currentColor",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6665 9.65885C6.6665 8.72543 6.6665 8.25872 6.84816 7.9022C7.00795 7.5886 7.26292 7.33363 7.57652 7.17384C7.93304 6.99219 8.39975 6.99219 9.33317 6.99219H15.6665C16.5999 6.99219 17.0666 6.99219 17.4232 7.17384C17.7368 7.33363 17.9917 7.5886 18.1515 7.9022C18.3332 8.25872 18.3332 8.72543 18.3332 9.65885V15.9922C18.3332 16.9256 18.3332 17.3923 18.1515 17.7488C17.9917 18.0624 17.7368 18.3174 17.4232 18.4772C17.0666 18.6589 16.5999 18.6589 15.6665 18.6589H9.33317C8.39975 18.6589 7.93304 18.6589 7.57652 18.4772C7.26292 18.3174 7.00795 18.0624 6.84816 17.7488C6.6665 17.3923 6.6665 16.9256 6.6665 15.9922V9.65885Z",
    stroke: "currentColor",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntersectSquare);
export default __webpack_public_path__ + "static/media/intersect-square.633f3e6f7cfe00994e6eef4afa788a95.svg";
export { ForwardRef as ReactComponent };